import { render, staticRenderFns } from "./columns-settings.vue?vue&type=template&id=079d0736&scoped=true&"
import script from "./columns-settings.vue?vue&type=script&lang=js&"
export * from "./columns-settings.vue?vue&type=script&lang=js&"
import style0 from "./columns-settings.vue?vue&type=style&index=0&id=079d0736&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079d0736",
  null
  
)

export default component.exports